export enum ZoomMode {
  Full = "Full",
  Medium = "Medium",
  Small = "Small",
  Tiny = "Tiny"
}
